var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestPlanningInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.9063 0.0144 5 0.0144 5 3.5004 0.9063 3.5004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.373 0.0004 21 0.0004 21 15 0.373 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.9063 0.0144 5 0.0144 5 3.5004 0.9063 3.5004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.373 0.0004 21 0.0004 21 15 0.373 15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test-Planing-Inactive.svg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9063,3.5004 L5.0003,3.5004 L5.0003,1.2504 C5.0003,0.7934 4.8613,0.3694 4.6283,0.0144 L0.9063,3.5004 Z",
    id: "Fill-1",
    fill: "#D2E1FA",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.75,3 L16.5,3 L16.5,0.75 C16.5,0.338 16.162,0 15.75,0 L14.25,0 C13.838,0 13.5,0.338 13.5,0.75 L13.5,3 L7.5,3 L7.5,0.75 C7.5,0.338 7.162,0 6.75,0 L5.25,0 C4.838,0 4.5,0.338 4.5,0.75 L4.5,3 L2.25,3 C1.008,3 0,4.008 0,5.25 L0,7.5 L16.906,7.5 L20.628,4.015 C20.226,3.404 19.535,3 18.75,3",
    id: "Fill-4",
    fill: "#D2E1FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,9.5634 C15,9.2534 15.253,9.0014 15.562,9.0014 L17.438,9.0014 C17.747,9.0014 18,9.2534 18,9.5634 L18,11.4384 C18,11.7484 17.747,12.0004 17.438,12.0004 L15.562,12.0004 C15.253,12.0004 15,11.7484 15,11.4384 L15,9.5634 Z M15,3.5634 C15,3.2534 15.253,3.0004 15.562,3.0004 L17.438,3.0004 C17.747,3.0004 18,3.2534 18,3.5634 L18,5.4384 C18,5.7484 17.747,6.0004 17.438,6.0004 L15.562,6.0004 C15.253,6.0004 15,5.7484 15,5.4384 L15,3.5634 Z M12,11.4384 C12,11.7484 11.747,12.0004 11.437,12.0004 L9.563,12.0004 C9.253,12.0004 9,11.7484 9,11.4384 L9,9.5634 C9,9.2534 9.253,9.0014 9.563,9.0014 L11.437,9.0014 C11.747,9.0014 12,9.2534 12,9.5634 L12,11.4384 Z M12,3.5634 L12,5.4384 C12,5.7484 11.747,6.0004 11.437,6.0004 L9.563,6.0004 C9.385,6.0004 9.233,5.9124 9.13,5.7834 L5.649,9.0434 C5.854,9.1274 6,9.3294 6,9.5634 L6,11.4384 C6,11.7484 5.747,12.0004 5.437,12.0004 L3.562,12.0004 C3.279,12.0004 3.052,11.7854 3.015,11.5114 L0.373,13.9864 C0.775,14.5954 1.465,15.0004 2.25,15.0004 L18.75,15.0004 C19.992,15.0004 21,13.9924 21,12.7504 L21,0.0004 L15.305,0.0004 L11.87,3.2174 C11.947,3.3134 12,3.4304 12,3.5634 L12,3.5634 Z",
    id: "Fill-6",
    fill: "#D2E1FA",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3,12.5629 C3,12.2529 3.253,12.0009 3.562,12.0009 L5.438,12.0009 C5.747,12.0009 6,12.2529 6,12.5629 L6,14.4379 C6,14.7479 5.747,15.0009 5.438,15.0009 L3.562,15.0009 C3.253,15.0009 3,14.7479 3,14.4379 L3,12.5629 Z M0,21.7499 C0,22.2069 0.138,22.6309 0.373,22.9859 L3.015,20.5119 C3.011,20.4859 3,20.4639 3,20.4379 L3,18.5629 C3,18.2539 3.253,18.0009 3.562,18.0009 L5.438,18.0009 C5.513,18.0009 5.584,18.0169 5.649,18.0439 L9.13,14.7829 C9.053,14.6879 9,14.5699 9,14.4379 L9,12.5629 C9,12.2529 9.253,12.0009 9.562,12.0009 L11.438,12.0009 C11.614,12.0009 11.767,12.0879 11.87,12.2179 L15.305,8.9999 L0,8.9999 L0,21.7499 Z",
    id: "Fill-9",
    fill: "#D2E1FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(16.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9063,3.5004 L5.0003,3.5004 L5.0003,1.2504 C5.0003,0.7934 4.8613,0.3694 4.6283,0.0144 L0.9063,3.5004 Z",
    id: "Fill-11",
    fill: "#B4CEFA",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,9.5634 C15,9.2534 15.253,9.0014 15.562,9.0014 L17.438,9.0014 C17.747,9.0014 18,9.2534 18,9.5634 L18,11.4384 C18,11.7484 17.747,12.0004 17.438,12.0004 L15.562,12.0004 C15.253,12.0004 15,11.7484 15,11.4384 L15,9.5634 Z M15,3.5634 C15,3.2534 15.253,3.0004 15.562,3.0004 L17.438,3.0004 C17.747,3.0004 18,3.2534 18,3.5634 L18,5.4384 C18,5.7484 17.747,6.0004 17.438,6.0004 L15.562,6.0004 C15.253,6.0004 15,5.7484 15,5.4384 L15,3.5634 Z M12,11.4384 C12,11.7484 11.747,12.0004 11.437,12.0004 L9.563,12.0004 C9.253,12.0004 9,11.7484 9,11.4384 L9,9.5634 C9,9.2534 9.253,9.0014 9.563,9.0014 L11.437,9.0014 C11.747,9.0014 12,9.2534 12,9.5634 L12,11.4384 Z M12,3.5634 L12,5.4384 C12,5.7484 11.747,6.0004 11.437,6.0004 L9.563,6.0004 C9.385,6.0004 9.233,5.9124 9.13,5.7834 L5.649,9.0434 C5.854,9.1274 6,9.3294 6,9.5634 L6,11.4384 C6,11.7484 5.747,12.0004 5.437,12.0004 L3.562,12.0004 C3.279,12.0004 3.052,11.7854 3.015,11.5114 L0.373,13.9864 C0.775,14.5954 1.465,15.0004 2.25,15.0004 L18.75,15.0004 C19.992,15.0004 21,13.9924 21,12.7504 L21,0.0004 L15.305,0.0004 L11.87,3.2174 C11.947,3.3134 12,3.4304 12,3.5634 L12,3.5634 Z",
    id: "Fill-14",
    fill: "#B4CEFA",
    mask: "url(#mask-8)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestPlanningInactive);
export default __webpack_public_path__ + "static/media/test-planning-inactive.584f7aca287b50fb38733da339ea2522.svg";
export { ForwardRef as ReactComponent };